import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  DurationCellRendererModule,
  FormatValueConversionCellRendererModule,
  TimeAgoCellRendererModule,
} from '@y42/ag-grid';
import { ContainerWithSideDetailViewModule } from '@y42/core/container-with-side-detail-view';
import { ListViewModule } from '@y42/core/list-view';
import { DateTimeModule } from '@y42/date-time';
import { ImportTypeCellRendererModule } from '../ag-grid/import-type-cell-renderer/import-type-cell-renderer.module';
import { JobStatusCellRendererModule } from '../ag-grid/job-status-cell-renderer/job-status-cell-renderer.module';
import { TriggeredByTypeCellRendererModule } from '../ag-grid/triggered-by-type-cell-renderer/triggered-by-type-cell-renderer.module';
import { JobInfoModule } from '../job-info';
import { RefreshJobsButtonModule } from '../refresh-jobs-button/refresh-jobs-button.module';
import { JobListViewContentComponent } from './job-list-view-content/job-list-view-content.component';
import { JobListViewDetailsComponent } from './job-list-view-details/job-list-view-details.component';
import { JobListViewComponent } from './job-list-view.component';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatProgressSpinnerModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    ImportTypeCellRendererModule,
    TimeAgoCellRendererModule,
    TriggeredByTypeCellRendererModule,
    JobStatusCellRendererModule,
    DurationCellRendererModule,
    FormatValueConversionCellRendererModule,
    ListViewModule,
    RefreshJobsButtonModule,
    JobInfoModule,
    ContainerWithSideDetailViewModule,
    DateTimeModule,
  ],
  declarations: [JobListViewComponent, JobListViewDetailsComponent, JobListViewContentComponent],
  exports: [JobListViewComponent],
})
export class JobListViewModule {}
